export const eAdvisorMenus = () => ({
    id: `main-menu-2-all`,
    path: '/management/e-advisor/dashboards',
    svg: (
        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
            <g id="SVGRepo_iconCarrier">
                <path fill="#ffffff" fillRule="evenodd" clipRule="evenodd" d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm-1.207 6.717L8.92 12.82a.5.5 0 0 1-.707.002l-.002-.002-1.414-1.414a.5.5 0 0 1 .002-.707l.002-.002 2.5-2.5a.5.5 0 0 1 .708 0l4.5 4.5a.5.5 0 0 1 0 .707l-2.5 2.5a.5.5 0 0 1-.706-.001l-.002-.002-1.415-1.415a.5.5 0 0 1-.001-.707l.001-.002 1.416-1.415z" />
            </g>
        </svg>

    ),
    label: 'Business Advisor',
    isEnabled: true,

    Description: 'eAdvisor is a enterprise dashboard and reports to visualize key metrics and data in one centralized location, allowing you to monitor and analyze information at a glance. Use our comprehensive reports to uncover trends, identify opportunities, and drive growth.',
    subMenu: [
        {
            id: `coln-1-collections`,
            label: 'Dashboards',
            path: '/management/e-advisor/dashboards',
            svg: (
                <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                    <g id="SVGRepo_iconCarrier">
                        <path fillRule="evenodd" clipRule="evenodd" d="M3.75 4.5L4.5 3.75H10.5L11.25 4.5V10.5L10.5 11.25H4.5L3.75 10.5V4.5ZM5.25 5.25V9.75H9.75V5.25H5.25ZM12.75 4.5L13.5 3.75H19.5L20.25 4.5V10.5L19.5 11.25H13.5L12.75 10.5V4.5ZM14.25 5.25V9.75H18.75V5.25H14.25ZM3.75 13.5L4.5 12.75H10.5L11.25 13.5V19.5L10.5 20.25H4.5L3.75 19.5V13.5ZM5.25 14.25V18.75H9.75V14.25H5.25ZM12.75 13.5L13.5 12.75H19.5L20.25 13.5V19.5L19.5 20.25H13.5L12.75 19.5V13.5ZM14.25 14.25V18.75H18.75V14.25H14.25Z" fill="#007BFF"></path>
                    </g>
                </svg>
            ),
            isEnabled: true,

        },
    ],
}
)
